import type { PropsWithChildren } from 'react'

import { FvButton, type FvButtonProps } from '@fv/client-components'

import { ShipperTooltip } from '@/components/ShipperTooltip'

import { useDownloadRatesPDF } from './useDownloadRatesPDF'

type Props = FvButtonProps & {
  loadId: string
  tooltip?: boolean
}

export const PrintRatesButton = ({
  loadId,
  tooltip,
  ...rest
}: PropsWithChildren<Props>) => {
  const { isFetchingFile, download } = useDownloadRatesPDF(loadId)
  return (
    <ShipperTooltip label={tooltip ? `Print rates` : ''}>
      <FvButton
        onClick={download}
        icon={isFetchingFile ? 'spinner' : 'print'}
        {...rest}
      >
        {rest.children}
      </FvButton>
    </ShipperTooltip>
  )
}
